import { MB, PC } from "./viewport_width";
import { isBrowser, isMobile } from "react-device-detect";
import { useEffect } from "react";
export default function Blank(props) {
  useEffect(() => {
    console.log("isMobiel = ", isMobile);
  }, []);
  return (
    <div
      style={{
        height: `${(props.height / (isMobile ? MB : PC)) * 100}vw`,
        backgroundColor: props.white === true ? "white" : "transparent",
      }}
    ></div>
  );
}
